import { ActionType } from '../constants/ActionTypes';
import { Constants } from '../constants/Constants';
import { RestPath } from '../constants/SitePaths'
import config from '../constants/Configs';
import axios from 'axios';

// Get Reports for Main (per game)
export const getReportForAffiliateBegin = () => ({
    type: ActionType.GET_REPORT_FOR_AFFILIATE_BEGIN
});

export const getReportForAffiliateSuccess = (data) => ({
    type: ActionType.GET_REPORT_FOR_AFFILIATE_SUCCESS,
    payload: data
});

export const getReportForAffiliateError = (data) => ({
    type: ActionType.GET_REPORT_FOR_AFFILIATE_ERROR,
    payload: data
});

// Get Reports for Sub (per )
export const getPaymentReportBegin = () => ({
    type: ActionType.GET_PAYMENT_REPORT_BEGIN
});

export const getPaymentReportSuccess = (data) => ({
    type: ActionType.GET_PAYMENT_REPORT_SUCCESS,
    payload: data
});

export const getPaymentReportError = (data) => ({
    type: ActionType.GET_PAYMENT_REPORT_ERROR,
    payload: data
});

// Get Reports Game Provider
export const getReportOperationTypeBegin = () => ({
    type: ActionType.GET_REPORT_OPERATION_TYPE_BEGIN
});

export const getReportOperationTypeSuccess = (data) => ({
    type: ActionType.GET_REPORT_OPERATION_TYPE_SUCCESS,
    payload: data
});

export const getReportOperationTypeError = (data) => ({
    type: ActionType.GET_REPORT_OPERATION_TYPE_ERROR,
    payload: data
});

// Get Reports Payments
export const getReportPaymentsBegin = () => ({
    type: ActionType.GET_REPORT_PAYMENTS_BEGIN
});

export const getReportPaymentsSuccess = (data) => ({
    type: ActionType.GET_REPORT_PAYMENTS_SUCCESS,
    payload: data
});

export const getReportPaymentsError = (data) => ({
    type: ActionType.GET_REPORT_PAYMENTS_ERROR,
    payload: data
});

export function getReportForAffiliate(mainPartnerId, pageNumber, formData) {
    return dispatch => {
        dispatch(getReportForAffiliateBegin());

        let params = formData ? {
            mainPartnerId,
            pageNumber,
            ...formData
        } : { mainPartnerId, pageNumber }

        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_REPORT_FOR_AFFILIATE,
            params: params

        }).then((response) => {
            dispatch(getReportForAffiliateSuccess(response.data));

            return response.data;
        })
            .catch((error) => {
                dispatch(getReportForAffiliateError(error));
            });
    }
}

export function getPaymentReport(affiliateId, pageNumber, formData) {
    return dispatch => {

        dispatch(getPaymentReportBegin());

        let params = formData ? {
            affiliateId,
            pageNumber,
            startDate: formData.startDate,
            endDate: formData.endDate,
            operationType: formData.operationType,
        } : { affiliateId, pageNumber }

        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_PAYMENT_REPORT,
            params: params

        }).then((response) => {
            dispatch(getPaymentReportSuccess(response.data));

            return response.data;
        })
            .catch((error) => {
                dispatch(getPaymentReportError(error));
            });
    }
}

// Get infos for dropdown
export function getReportOperationType() {
    return dispatch => {
        dispatch(getReportOperationTypeBegin());

        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_REPORT_OPERATION_TYPE,

        }).then((response) => {
            dispatch(getReportOperationTypeSuccess(response.data));

            return response.data;
        })
            .catch((error) => {
                dispatch(getReportOperationTypeError(error));
            });
    }
}

export function getReportPayments() {
    return dispatch => {
        dispatch(getReportPaymentsBegin());

        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_REPORT_PAYMENTS,

        }).then((response) => {
            dispatch(getReportPaymentsSuccess(response.data));

            return response.data;
        })
            .catch((error) => {
                dispatch(getReportPaymentsError(error));
            });
    }
}


// WEBPACK FOOTER //
// ./src/actions/ReportsAction.js